var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVpnKey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "vpn-key_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#vpn-key_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9292AF",
  d: "M12.706 19.778q-1.767 1.768-4.242 1.768T4.22 19.778t-1.768-4.243 1.768-4.242a5.77 5.77 0 0 1 2.723-1.556 6.2 6.2 0 0 1 3.075 0l6.223-6.223q.583-.583 1.414-.584.831 0 1.414.584l1.415 1.415q.583.583.583 1.413t-.583 1.415l.707.707q.583.583.584 1.414 0 .831-.584 1.415l-1.415 1.414q-.583.583-1.413.583a1.93 1.93 0 0 1-1.415-.583L16.242 12l-1.98 1.98a6.2 6.2 0 0 1 0 3.075 5.77 5.77 0 0 1-1.556 2.723m-1.414-1.414q1.167-1.167 1.159-2.59-.01-1.423-.558-2.254l4.349-4.349 2.121 2.122 1.415-1.415-2.122-2.121 1.414-1.414-1.414-1.414-7.177 7.177q-.83-.548-2.254-.557t-2.59 1.158Q4.47 13.873 4.47 15.535t1.166 2.829 2.829 1.166q1.662 0 2.828-1.166m-1.414-1.415q.583-.583.583-1.414 0-.83-.583-1.414a1.93 1.93 0 0 0-1.415-.583q-.83 0-1.413.583t-.584 1.413q0 .833.584 1.415.583.584 1.414.583.83 0 1.414-.583"
}))));
export default SvgVpnKey;